import { jsPDF } from "jspdf";
import { PARTS, SKILLS } from "@/data/parts";
import { mockTitle, mixLabel } from "@/data/mocks";
import { PASS_SCORE, cefr } from "@/lib/scoring";

const INDIGO = [79, 70, 229], SLATE = [15, 23, 42], GREEN = [16, 185, 129], RED = [239, 68, 68];
const preview = (it) => it.item.text || it.item.sentence || it.item.answer || it.item.question || it.item.title || "";
const respText = (r = {}) => r.text ?? [r.summary, r.opinion].filter(Boolean).join(" | ");

export const downloadReportPdf = (e) => {
  const doc = new jsPDF({ unit: "pt", format: "a4" });
  const W = doc.internal.pageSize.getWidth(), H = doc.internal.pageSize.getHeight(), M = 40;
  doc.setFillColor(...SLATE); doc.rect(0, 0, W, 90, "F");
  doc.setTextColor(255); doc.setFont("helvetica", "bold"); doc.setFontSize(20); doc.text("LexVersant — VEPT Score Report", M, 42);
  doc.setFont("helvetica", "normal"); doc.setFontSize(10); doc.text(`${mockTitle(e)}  ·  ${new Date(e.date).toLocaleString()}${mixLabel(e) ? `  ·  Mix: ${mixLabel(e)}` : ""}`, M, 64);

  doc.setTextColor(...SLATE); doc.setFont("helvetica", "bold"); doc.setFontSize(54); doc.text(String(e.overall), M, 170);
  doc.setFontSize(11); doc.setFont("helvetica", "normal"); doc.text(`Overall (20–80)  ·  CEFR approx. ${cefr(e.overall)}`, M, 192);
  doc.setFillColor(...((e.overall >= PASS_SCORE) ? GREEN : RED)); doc.roundedRect(M + 140, 132, 200, 30, 15, 15, "F");
  doc.setTextColor(255); doc.setFont("helvetica", "bold"); doc.setFontSize(12);
  doc.text((e.overall >= PASS_SCORE) ? `Met Target (${PASS_SCORE}+)` : `Below Target (<${PASS_SCORE})`, M + 240, 152, { align: "center" });

  let y = 230;
  doc.setTextColor(...SLATE); doc.setFontSize(13); doc.text("Skill sub-scores", M, y); y += 18;
  SKILLS.forEach((s) => {
    const v = e.skills[s];
    doc.setFont("helvetica", "normal"); doc.setFontSize(11); doc.text(s.charAt(0).toUpperCase() + s.slice(1), M, y + 9);
    doc.setFillColor(226, 232, 240); doc.rect(M + 90, y, 330, 10, "F");
    doc.setFillColor(...(v >= PASS_SCORE ? GREEN : INDIGO)); doc.rect(M + 90, y, 330 * ((v - 20) / 60), 10, "F");
    doc.setFont("helvetica", "bold"); doc.text(`${v}  (${cefr(v)})`, M + 435, y + 9); y += 22;
  });

  y += 14; doc.setFontSize(13); doc.text("Part breakdown", M, y); y += 16;
  const parts = PARTS.filter((p) => e.parts[p.key] != null);
  const colW = (W - 2 * M) / parts.length;
  parts.forEach((p, i) => {
    const x = M + i * colW;
    doc.setDrawColor(226, 232, 240); doc.rect(x, y, colW - 4, 40);
    doc.setFont("helvetica", "normal"); doc.setFontSize(8); doc.text(`Part ${p.key}`, x + 5, y + 13);
    doc.setFont("helvetica", "bold"); doc.setFontSize(13); doc.text(`${Math.round(e.parts[p.key] * 100)}%`, x + 5, y + 31);
  });
  y += 64;

  doc.setFontSize(13); doc.text("Question-by-question review", M, y); y += 16;
  e.items.forEach((it, i) => {
    const prompt = doc.splitTextToSize(`${i + 1}. [Part ${it.part}] ${preview(it)}`, W - 2 * M - 50);
    const resp = doc.splitTextToSize(`Your response: ${respText(it.response) || "—"}`, W - 2 * M - 50);
    const h = (prompt.length + resp.length) * 11 + 8;
    if (y + h > H - 40) { doc.addPage(); y = 50; }
    doc.setFont("helvetica", "bold"); doc.setFontSize(9); doc.setTextColor(...SLATE); doc.text(prompt, M, y);
    doc.setTextColor(...(it.score >= 0.7 ? GREEN : it.score >= 0.4 ? [217, 119, 6] : RED)); doc.text(`${Math.round(it.score * 100)}%`, W - M, y, { align: "right" });
    doc.setFont("helvetica", "normal"); doc.setTextColor(100, 116, 139); doc.text(resp, M, y + prompt.length * 11);
    y += h;
  });

  const pages = doc.getNumberOfPages();
  for (let p = 1; p <= pages; p++) { doc.setPage(p); doc.setFontSize(8); doc.setTextColor(148, 163, 184); doc.text(`LexVersant practice report — not an official Pearson score · Page ${p}/${pages}`, W / 2, H - 20, { align: "center" }); }
  doc.save(`LexVersant-${mockTitle(e).replace(/\s+/g, "-")}-${e.date.slice(0, 10)}.pdf`);
};
